<template>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="content">
          <div class="my-left">
            <div class="my-user">
              <div style="height: 80px; width: 80px; margin: 0 auto;border-radius:50%;overflow: hidden;">
                <el-image
                  style="width: 79px; height: 79px; vertical-align: middle;"
                  :src="userInfo.avatar"
                ></el-image>
<!--                <el-avatar size="medium" :src="userInfo.avatar"></el-avatar>-->
              </div>
              <div
                style="text-align: center; line-height: 50px; color: #f77f00"
              >
                {{userInfo.username}}
              </div>
            </div>
            <div class="tabs" :class="{'isactive': id == 1 }"  @click='tabClick(1)'>关联老人服务信息</div>
            <div class="tabs" :class="{'isactive':  id == 2}" @click='tabClick(2)'>预约申请记录</div>
            <!-- <div class="tabs" :class="{'isactive':  id == 3}" @click='tabClick(3)'>服务记录</div> -->
            <div class="tabs" :class="{'isactive':  id == 4}" @click='tabClick(4)'>反馈信息</div>
            <div class="tabs" :class="{'isactive':  id == 5}" @click='tabClick(5)'>申请老人</div>
            <div class="tabs" :class="{'isactive':  id == 6}" @click='tabClick(6)'>修改密码</div>
          </div>
          <div class="my-right">
               <relevance v-if='id == 1'></relevance>
              <order  v-if='id == 2'></order>
              <!-- <service  v-if='id == 3'></service> -->
            <feedback  v-if='id == 4'></feedback>
            <addOldMan  v-if='id == 5'></addOldMan>
            <psw  v-if='id == 6'></psw>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";
 import relevance from "./public/relevance";
 import order from "./public/order";
 import service from "./public/service";
import feedback from "./public/feedback";
import addOldMan from "./public/addOldMan";
import psw from "./public/passward";

export default {
  name: "myCenter",
   components: { headerList,relevance, order,service,feedback,addOldMan,psw},
  data() {
    return {
      userInfo: {},
      passForm: {
        password: "",
        checkPass: "",
        currentPass: "",
      },
      activeName: "first",
      id:this.$route.query.type,
      userInfo:''
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
  },
  methods: {
      tabClick(res){
          this.id=res;
        this.$router.push({
          path: "/myCenter",
          name: "myCenter",
          query: {
            type:res,
          },
        });
        // this.$router.go(0);
      }
  },
};
</script>

<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  margin: auto;
 background: #FDFBF5;
}
.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 7.1875rem /* 115px -> 7.1875rem */ !important;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}

.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
.content {
  margin: 9.375rem /* 150px -> 9.375rem */ 6.25rem /* 100px -> 6.25rem */;
}
.my-left {
  float: left;
  width: 15%; /* 320px -> 20rem */;
  height: 40rem /* 450px -> 28.125rem */;
  margin: 0 5%; /* 20px -> 1.25rem */;
  background: #fff;
}
.my-right {
  float: left;
  width: 65%; /* 1266px -> 79.125rem */;
  height: 54.125rem /* 866px -> 54.125rem */;
  background: #fff;
}
.my-user {
  height: 11.25rem /* 180px -> 11.25rem */;
  width: 80%;
  margin: 1.25rem /* 20px -> 1.25rem */ auto;
}
.tabs {
  width: 100%; /* 320px -> 20rem */;
  height: 4.0625rem /* 65px -> 4.0625rem */;
  line-height: 4.0625rem /* 65px -> 4.0625rem */;
  text-align: center;
  font-size: 1.25rem /* 20px -> 1.25rem */;
font-family: Microsoft YaHei;
font-weight: 400;
color: #6D6053;
  cursor:pointer;
}
    .isactive{
        background: #F77F00;
        color:#fff;
    }
</style>